import { render, staticRenderFns } from "./DirectionStat.vue?vue&type=template&id=4f95b31c&"
import script from "./DirectionStat.vue?vue&type=script&lang=js&"
export * from "./DirectionStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports